<template>
    <div v-if="field">
        <IdentityFields :label="$translateLabel(field.label, field.name)" :field="field" v-model="input" @error="fieldError" :disabled="field.protected" :page="page" :store="$store" :context="context" :translator="$t" v-bind="$attrs" v-on="$listeners">
            <template v-slot:ProvidedTemplate>
                <ComponentView :id="field.provided_template_component" :entrypoint="field.component_template" :field="field" :context="context" v-model="input" :key="field.key" :page="page" v-bind="$attrs" v-on="$listeners"/>
            </template>
        </IdentityFields>
    </div>
</template>

<script>
import IdentityFields from '@/components/identityFields/IdentityFields'
import ComponentView from '@/components/base/ComponentView'
import _ from 'lodash'
import { 
    Context,
} from '@protokol/platform-libs'

export default {
    components: {
        IdentityFields,
        ComponentView
    },
    props: {
        field: {
            type: Object
        },

        model: {
            type: Object
        },

        fields: {
            type: Array
        },

        isEdit: {
            type: Boolean
        },

        id: {
            type: String
        }
    },

    data: function() {
        return {
            errors: [],
            data: {}
        }  
    },

    computed: {
        input: {
            get() {
                return this.model
            },
            
            set(e) {
                this.data = Object.assign({}, this.data, e)
                this.$emit('modelChanged', this.data)
            }
        },

        context() {
            return new Context({
                model: _.cloneDeep(this.model), 
                fields: this.fields,
                component: this.component,
                locale: this.$store.getters.getLocale
            })
        },

        page() {
            if (this.isEdit) return 'model_edit'

            return 'model_create'
        }
    },

    methods: {
        fieldError(error) {
            let found = this.errors.find((i) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }

            this.$emit('error', this.errors)
        }
    }
}
</script>